import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { getToken } from "./graphql/token";
import Candidate from "./routes/Candidate/page";
import Signin from "./routes/SignIn/page";
import PrivacyPolicy from "./routes/Privacy-Policy/page";
import PublishedJobs from "./routes/PublishedJobs/page";
import UpdateCompany from "./routes/UpdateCompany/page";
import CandidatesList from "./routes/CandidatesList/page";
import Logout from "./routes/Logout/page";
import CompanyManagement from "./routes/CompanyManagement/page";
import Root from "./routes/Root/page";
import { Helmet } from "react-helmet-async";

function App() {
  const token = getToken();

  const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    if (!token) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <>
      <Helmet>
        <title>سامانه لایت کارجوپلاس | مدیریت جذب و استخدام بسیار ساده</title>
        <link rel="canonical" href={window.location.href} />
        <meta
          name="description"
          content="ثبت آگهی استخدام و مدیریت اطلاعات درخواست های همکاری و رزومه های ارسالی تنها با 3 قدم آسان"
        />
        <meta name="keywords" content="استخدام,مدیریت جذب,آگهی استخدام,کارجو" />
        <meta
          property="og:title"
          content="سامانه لایت کارجوپلاس | مدیریت جذب و استخدام بسیار ساده"
        />
        <meta
          property="og:description"
          content="ثبت آگهی استخدام و مدیریت اطلاعات درخواست های همکاری و رزومه های ارسالی تنها با 3 قدم آسان"
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="favicon.ico" />
        <meta property="og:image:secure_url" content="favicon.ico" />
        <meta property="og:image:width" content="100" />
        <meta property="og:image:alt" content={`Image of ${"ATS lite"} site`} />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:image" content="favicon.ico" />
        <meta
          name="twitter:title"
          content="سامانه لایت کارجوپلاس | مدیریت جذب و استخدام بسیار ساده"
        />
        <meta
          name="twitter:description"
          content="ثبت آگهی استخدام و مدیریت اطلاعات درخواست های همکاری و رزومه های ارسالی تنها با 3 قدم آسان"
        />
      </Helmet>

      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/company-management" element={<CompanyManagement />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/candidate/:id"
          element={<ProtectedRoute children={<Candidate />} />}
        />
        <Route
          path="/candidates"
          element={<ProtectedRoute children={<CandidatesList />} />}
        />
        <Route
          path="/update-company/:companyId"
          element={<ProtectedRoute children={<UpdateCompany />} />}
        />
        <Route
          path="/jobs"
          element={<ProtectedRoute children={<PublishedJobs />} />}
        />
      </Routes>
    </>
  );
}

export default App;
